import { X } from 'lucide-react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dispatch, FC, SetStateAction } from 'react';

interface Props {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
}

const BaselineProjectionModal: FC<Props> = ({ visible, setVisible }) => {
  return (
    <Dialog
      visible={visible}
      modal
      className="!tw-max-h-full"
      style={{ width: '50vw', height: '70vh' }}
      onHide={() => setVisible(false)}
      content={
        <div className='"tw-flex tw-flex-col tw-gap-y-2 tw-p-8 tw-overflow-y-auto'>
          <div className="tw-flex tw-flex-row tw-justify-between tw-items-center tw-pb-4">
            <h1 className="tw-font-atkinson tw-text-2xl tw-text-neutral-950 tw-font-bold">Baseline Projection</h1>
            <Button
              icon={<X size={16} className="tw-text-neutral-950 hover:tw-text-white" />}
              onClick={() => setVisible(false)}
              aria-label="Close"
              outlined
              className="tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer"
            />
          </div>
          <div className="tw-flex tw-flex-col">
            <p className="tw-font-atkinson tw-text-lg tw-text-neutral-600 tw-m-0 tw-mb-2">
              Based on each student&apos;s diagnostic starting point and learning 2 new skills per week, here&apos;s
              where we project students can land by end of year in terms of grade level proficiency.<br></br>
              <br></br> This prediction is static and does not update as students continue to use the program.
            </p>
            <h1 className="tw-font-atkinson tw-text-base tw-text-neutral-600 tw-font-bold tw-mb-3">
              What do these projections mean?
            </h1>
            <span className="tw-text-xs tw-font-atkinson tw-font-bold tw-px-3 tw-py-1 tw-bg-sky-50 tw-border tw-border-solid tw-rounded-lg tw-border-sky-200 tw-w-[95px] tw-text-center">
              On track
            </span>
            <p className="tw-font-atkinson tw-text-base tw-text-neutral-600 tw-m-0 tw-mb-3">
              Projected to complete 75–100% of their Roadmap by EOY if they stay consistent. Our data shows passing 75%
              of Roadmap skills is a strong predictor of end-of-year exam proficiency.
            </p>
            <span className="tw-text-xs tw-font-atkinson tw-font-bold tw-px-3 tw-py-1 tw-bg-amber-50 tw-border tw-border-solid tw-rounded-lg tw-border-amber-400 tw-w-[95px] tw-text-center">
              Approaching
            </span>
            <p className="tw-font-atkinson tw-text-base tw-text-neutral-600 tw-m-0 tw-mb-3">
              Projected to complete less than 75% of their Roadmap by EOY. These students may need additional support to
              hit grade level proficiency.
            </p>
            <Divider className="tw-w-full" />
            <Button link className="tw-ml-auto" label="Close" onClick={() => setVisible(false)} />
          </div>
        </div>
      }
    ></Dialog>
  );
};

export default BaselineProjectionModal;
